import { Component, OnInit } from '@angular/core';
import { CurrentPageWatcherService } from '../utils/CurrentPageWatcher';
import { Router } from '@angular/router';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {
  title: string ="Privacy Policy";
  constructor(private currentPageWatcher:CurrentPageWatcherService,private router:Router) { 
    this.currentPageWatcher.notifyLeftMenuDisplay().emit(false);
  }

  ngOnInit() {
    this.currentPageWatcher.pageChanged().emit(this.title);
  }

  goBackHome(){
    this.router.navigate(['/home']);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/privacy-policy/privacy-policy.component.ts